import Vue from 'vue'
import VueRouter from 'vue-router'

// Routes
import { canNavigate } from '@/libs/acl/routeProtection'
import permissionService from '@/shared/services/permissionService'
import { isUserLoggedIn, getUserData, getHomeRouteForLoggedInUser } from '@/auth/utils'
import dashboard from './routes/dashboard'
import portefeuilles from './routes/portefeuilles'
import calendries from './routes/calendries'
import messageries from './routes/messageries'
import animationCommerciale from './routes/assureur/animation-commerciale'
import statistiques from './routes/assureur/statistiques'
import parametres from './routes/assureur/parametres'
import portefeuille from './routes/assureur/portefeuille'
import organisation from './routes/assureur/organisation'
import tiers from './routes/tiers'
import projets from './routes/projets'
import commissions from './routes/commissions'
import catalogues from './routes/catalogues'
import cabinet from './routes/cabinet'
import faqs from './routes/faqs'
import outils from './routes/outils'
import webinars from './routes/webinars'
import backOffice from './routes/back-office'
import conformite from './routes/conformite'
import universign from './routes/universign'
import quickwinsTarification from './routes/quickwins/tarification'
import axios from '@axios'
import monContactBubblin from './routes/mon-contact-bubblin'
import globalParametres from '@/shared/api/globalParametres'

Vue.use(VueRouter)

let host = window.location.host;



const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [
    { path: '/', redirect: { name: 'home-page' } },
    ...dashboard,
    ...messageries,
    ...tiers,
    ...projets,
    ...portefeuilles,
    ...portefeuille,
    ...commissions,
    ...conformite,
    ...calendries,
    ...catalogues,
    ...animationCommerciale,
    ...statistiques,
    ...organisation,
    ...cabinet,
    ...faqs,
    ...outils,
    ...webinars,
    ...backOffice,
    ...parametres,
    ...universign,
    ...quickwinsTarification,
    ...monContactBubblin,
    
    {
      path: '/not-authorized',
      name: 'page-not-authorized',
      component: () => import('@/views/not-authorized/NotAuthorized.vue'),
      meta: {
        layout: 'full',
        resource: 'Auth',
      },
    },
    {
      path: '*',
      redirect: 'error-404',
    },
  ],
})

router.beforeEach((to, _, next) => {
  
  // console.log('--------');
  const isLoggedIn = isUserLoggedIn()
  // console.log(isLoggedIn);

  
  const url = window.location.href.toLowerCase();

  if (url.includes('un-pack-de-formation-dda')) {
    localStorage.setItem('url', window.location.href);
  }


  if (!canNavigate(to)) {
    // Redirect to login if not logged in
    if (!isLoggedIn) return next({ name: 'auth-login' })

    // If logged in => not authorized
    //return next({ name: 'misc-not-authorized' })
  }

  // Redirect if logged in
  if (to.meta.redirectIfLoggedIn && isLoggedIn) {
    const userData = getUserData()
    // next(getHomeRouteForLoggedInUser(userData ? userData.role : null))
    next(getHomeRouteForLoggedInUser(userData ? userData : null))
  }
  if (isLoggedIn && !permissionService.methods.hasPermission(to.name) && to.name != 'error-404')
    return next({ name: 'error-404' })

  if (isLoggedIn && getUserData().type_utilisateur != 'assureur') {
    axios
      .post('/statistiques/sessions/tracking', { page: to.name })
      .then(r => { })
      .catch(err => { })
  }
  // if(pages){
  //   pages.push(to.name);
  //   localStorage.setItem('userPages', JSON.stringify(pages))
  //   // console.log(to.name,pages)
  // }

  /* set page visited */
  return next()
})

// ? For splash screen
// Remove afterEach hook if you are not using splash screen
router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = 'none'
  }
})

export default router
